<app-item-sell [item]="item"></app-item-sell>
<!--<app-item-insert [item]="item"></app-item-insert>-->
<app-item-update [item]="item"></app-item-update>
<app-item-delete [item]="item"></app-item-delete>
